import React, { useState, useEffect } from 'react';
import './LocalConsentBanner.css';


/**
 * Local Consent Banner Component
 * Displays a mock consent banner for local development to debug cookie issues
 */
const LocalConsentBanner = ({ onAccept, onReject }) => {
  const [visible, setVisible] = useState(true);
  const [cookies, setCookies] = useState([]);
  const [expanded, setExpanded] = useState(false);

  // Parse document.cookie string into an array of objects
  const parseCookies = () => {
    const cookiesArr = document.cookie.split(';');
    const cookieObjects = cookiesArr.map(cookie => {
      const parts = cookie.trim().split('=');
      return {
        name: parts[0],
        value: parts.length > 1 ? parts[1] : '',
      };
    });
    setCookies(cookieObjects);
  };

  useEffect(() => {
    // Check cookies initially
    parseCookies();
    
    // Set up a cookie change observer
    const cookieObserver = setInterval(() => {
      parseCookies();
    }, 1000);
    
    return () => clearInterval(cookieObserver);
  }, []);

  const handleAccept = () => {
    // Store consent in localStorage
    localStorage.setItem('dev_cookies_accepted', 'true');
    
    // Log for debugging
    console.log('LOCAL DEV: Cookies accepted');
    console.log('Current cookies before accept:', document.cookie);
    
    // Execute callback
    if (onAccept) onAccept();
    
    // Hide the banner
    setVisible(false);
  };

  const handleReject = () => {
    // Store rejection in localStorage
    localStorage.setItem('dev_cookies_accepted', 'false');
    
    // Log for debugging
    console.log('LOCAL DEV: Cookies rejected');
    
    // Execute callback
    if (onReject) onReject();
    
    // Hide the banner
    setVisible(false);
  };

  const toggleDetails = () => {
    setExpanded(!expanded);
  };

  // If consent was already given/rejected in this session, don't show the banner
  if (!visible || localStorage.getItem('dev_cookies_accepted') !== null) {
    return null;
  }

  return (
    <div className="banner-overlay">
      <h3 className="banner-title">Cookie Consent (LOCAL DEBUG MODE)</h3>
      <p className="banner-text">
        This local banner simulates the Usercentrics banner to debug cookie persistence issues.
        Accept cookies to enable chat history and personalization features.
      </p>
      
      <div className="button-container">
        <button className="button accept-button" onClick={handleAccept}>Accept All Cookies</button>
        <button className="button reject-button" onClick={handleReject}>Reject All</button>
        <button className="button details-button" onClick={toggleDetails}>
          {expanded ? 'Hide Details' : 'Show Cookie Debug Info'}
        </button>
      </div>
      
      {expanded && (
        <div className="cookie-info">
          <div><strong>Current Cookies ({cookies.length}):</strong></div>
          {cookies.length > 0 ? (
            cookies.map((cookie, index) => (
              <div key={index}>
                {cookie.name}: {cookie.value.substring(0, 20)}{cookie.value.length > 20 ? '...' : ''}
              </div>
            ))
          ) : (
            <div>No cookies found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default LocalConsentBanner;
